<script lang="ts" setup>
import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';
import { i18n } from '@/i18n';
import { useRegisterSettingStore } from './RegisterSettingStore';
import { storeToRefs } from 'pinia';
import FirstRegister from './components/FirstRegister.vue';
import HomeInput from './components/inputSetting/HomeInput.vue';
import UploadBusiness from './components/registerSetting/UploadBusiness.vue';
import UploadInput from './components/inputSetting/UploadInput.vue';
import LinkingBusiness from './components/registerSetting/LinkingBusiness.vue';
import FinishBusiness from './components/registerSetting/FinishBusiness.vue';
import { RegisterExcelBusinessInfoUseCase } from '../useCases/registerExcelBusinessInfoUseCase';
import { BusinessExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/BusinessExcelInfosRepository';
import { UpsertBusinessesFromExcelUseCase } from '../useCases/UpsertBusinessesFromExcelUseCase';
import { UpsertBusinessesRepository } from '@/coreInfrastructureModule/Repositories/UpsertBusinessesRepository';
import { CreateCsvUseCase } from '@/exportFileUseCasesModule/createCsvUseCase';
import LinkingInput from './components/inputSetting/LinkingInput.vue';
import { PutExcelInputInfoAdapter } from '../adapters/PutExcelInputInfoAdapter';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';
import { RegisterExcelInputInfoUseCase } from '../useCases/RegisterExcelInputInfoUseCase';
import FinishInput from './components/inputSetting/FinishInput.vue';
import { GetInputExcelInfoUseCase } from '../useCases/GetInputExcelInfoUseCase';
import { GetExcelInputInfoAdapter } from '../adapters/GetExcelInputInfoAdapter';
import { GetExcelBusinessInfoUseCase } from '../useCases/GetExcelBusinessInfoUseCase';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';
const t = i18n.t;

const store = useRegisterSettingStore(
  new GetInputExcelInfoUseCase(),
  new GetExcelInputInfoAdapter(),
  new GetExcelBusinessInfoUseCase(),
  new RegisterExcelBusinessInfoUseCase(),
  new BusinessExcelInfosRepository(),
  new UpsertBusinessesFromExcelUseCase(),
  new CreateCsvUseCase(),
  new RegisterExcelInputInfoUseCase(),
  new UpsertBusinessesRepository(),
  new InputExcelInfosRepository(),
  new PutExcelInputInfoAdapter(),
  new SettingRepository()
)();
const { state } = storeToRefs(store);
</script>

<template>
  <div class="register-setting">
    <div class="register-setting__title register-setting-title">
      <span class="register-setting-title__label">{{ t('登録/入力') }}</span>
    </div>

    <RegisterBusinessPageTab class="register-setting__page-tab" />

    <div class="register-setting__contains contains">
      <div v-if="state.mode === 'FirstRegister'" class="contains__first-register">
        <FirstRegister
          @on-click-back="() => {}"
          @on-click-next="store.onClickFirstPageNext"
          @on-click-download-template="() => {}"
          @on-click-register-setting="() => {}"
        />
      </div>

      <div v-if="state.mode === 'HomeInput'" class="contains__home-input">
        <HomeInput :register-setting-store="store" />
      </div>

      <div v-if="state.mode === 'UploadBusiness'" class="contains__upload-business">
        <UploadBusiness :store="store" @on-click-back="store.onClickUploadBusinessBack" @on-click-next="store.onClickUploadBusinessNext" />
      </div>

      <div v-if="state.mode === 'UploadInput'" class="contains__upload-input">
        <UploadInput :store="store" @on-click-back="store.onClickUploadInputBack" @on-click-next="store.onClickUploadInputNext" />
      </div>

      <div v-if="state.mode === 'LinkingBusiness'" class="contains__linking-business">
        <LinkingBusiness
          :store="store"
          @on-click-back="store.onClickLinkingBusinessBack"
          @on-click-next="store.onClickLinkingBusinessNext"
          @on-click-use-previous-value="store.onClickLinkingBusinessUsePreviousValue"
        />
      </div>

      <div v-if="state.mode === 'LinkingInput'" class="contains__linking-input">
        <LinkingInput :store="store" @on-click-back="store.onClickLinkingInputBack" @on-click-next="store.onClickLinkingInputNext" />
      </div>

      <div v-if="state.mode === 'FinishBusiness'" class="contains__finish-business">
        <FinishBusiness :store="store" @on-click-back="store.onClickFinishBusinessBack" />
      </div>

      <div v-if="state.mode === 'FinishInput'" class="contains__finish-input">
        <FinishInput :store="store" @on-click-back="store.onClickFinishInputBack" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.register-setting {
  display: grid;
  gap: 8px;
  margin: 16px;

  &__title {
    font-family: Noto Sans JP;
    font-size: 22px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0em;
    text-align: left;
    color: $textDefault;
  }

  &__contains {
    display: grid;
    &--loading {
      align-self: center;
      height: 100%;
    }
  }
}

.register-setting-title {
  display: grid;
  grid-template-columns: repeat(2, fit-content(100%));
  align-items: center;
  column-gap: 48px;
  &__label {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
  }
}
</style>
